import coralSVG from '../../../icons/coral.svg';
import flowerSVG from '../../../icons/flower.svg';
import shellSVG from '../../../icons/shell.svg';
import starfishSVG from '../../../icons/starfish.svg';

/**
 * Vocabulário FECHADO de ícones do tema para o bloco Icon Cards.
 * Sem upload — apenas os SVGs de linha já existentes em `src/icons/`.
 * Ver docs/specs/schema-decisions.md §3 e §D4.
 */
export const iconRegistry: Record<string, unknown> = {
  coral: coralSVG,
  flower: flowerSVG,
  shell: shellSVG,
  starfish: starfishSVG,
};

export type IconCardIconName = keyof typeof iconRegistry;
